export function determineQuadrantClass(value?: Boolean | null) {
    if (value === undefined) {
        return 'unknown';
    } else if (value === null) {
        return 'not-applicable';
    }
    return value ? 'good' : 'bad';
}
